import {
  useCallback,
  useState,
} from 'react';
import { BusinessModel } from '../../interfaces/BusinessModel.interface';
// import submitIntake from '../../services/intake/submitIntake';

const useChargebeeCompleteCallback = (business: BusinessModel | undefined, callback: () => void) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();

  const onChargebeeComplete = useCallback(
    async () => {
      setError(null);
      setLoading(true);
      if (business) {
        try {
          // await submitIntake(business);
          callback();
        } catch (err) {
          setError(err);
        }
        setLoading(false);
      }
    },
    [business],
  );

  return [onChargebeeComplete, loading, error];
};

export default useChargebeeCompleteCallback;
